import React from 'react';

/**
 * Components
 */
import { Input } from 'Components/Input';

class MatrixInput extends React.Component {

  render() {
    const {areas, table, handleMatrixChange, invalidCells, showSelectedAreaPicture, showDefaultAreaPicture} = this.props;

    return (
      <section className={'matrix-input-section'}>
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th />
              {table.columns.map(column => {
                return <th key={column.name}>{column.name}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {table.rows.map(row => (
              <tr key={row.name} className={!row.isInput ? 'output' : ''}>
                <td>{row.name}</td>
                {table.columns.map(column => {
                  return (
                    <td
                      key={row.name + column.name}
                      className={invalidCells[column.targetFieldId][row.targetFieldId] && 'invalid-cell'}
                    >
                      {row.isInput ? (
                        <Input
                          isNumeric
                          unitsTop={10}
                          inputClassName='_height_pc_100 _width_pc_100'
                          inputFieldWrapperClassName='_height_pc_100'
                          key={row.name + column.name + 'output'}
                          value={
                            areas[column.targetFieldId][row.targetFieldId] !== undefined
                              ? areas[column.targetFieldId][row.targetFieldId]
                              : ''
                          }
                          onChange={handleMatrixChange(column.targetFieldId, row.targetFieldId)}
                          onBlur={showDefaultAreaPicture}
                          onFocus={showSelectedAreaPicture(row.targetFieldId)}
                          units={row.units || column.units}
                          digitsAfterDot={row.digitsAfterDot}
                          allowNegative={!!row.allowNegative}
                        />
                      ) : (
                        <div className='table-output'>
                          {(areas[column.targetFieldId][row.targetFieldId]
                            ? areas[column.targetFieldId][row.targetFieldId].toFixed(2)
                            : '') +
                            ' ' +
                            row.units || column.units}
                        </div>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    );
  }
}

export default MatrixInput;



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/CubicCapacityScene/MatrixInput.jsx